export enum GameStateEnum {
  COUNTDOWN = "countdown",
  CLIMBING = "climbing",
  CRASHED = "crashed",
}
export type GameState = `${GameStateEnum}`;
